import { Close } from 'app/assets/icons'
import { media } from 'app/assets/styles'
import BlazonModalBody from 'app/common/modals/blazon/body/BlazonModalBody'
import { BlazonModalHeader } from 'app/common/modals/blazon/header/BlazonModalHeader'
import useClickOutside from 'hooks/listeners/useClickOutside.hooks'
import React, { useRef } from 'react'
import { colors } from 'shared/assets/styles'
import type { Blazon } from 'shared/types'
import styled from 'styled-components'

const { text } = colors

type Props = {
    blazon: Blazon,
    onClose: Function
}

const BlazonModal = (props: Props) => {
    const { blazon, onClose } = props

    const ref = useRef(null)
    useClickOutside(ref, onClose)

    return (
        <Root innerRef={ref}>
            <CloseButtonContainer onClick={onClose}>
                <Close color={text} size={24} />
            </CloseButtonContainer>
            <BlazonModalHeader blazon={blazon} />
            <BlazonModalBody blazon={blazon} />
        </Root>
    )
}

const Root = styled.div`
    position: relative;
    height: auto;
    padding: 0 20px 32px;
    ${media.small`
        padding: 0 40px 32px;
    `};
    ${media.medium`
        max-height: calc(100% - 40px);
    `};
`

const CloseButtonContainer = styled.span`
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
`

export { BlazonModal }
